
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next-booty",
      function () {
        return require("private-next-pages/next-booty.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/next-booty"])
      });
    }
  